// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import { Button, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import PubSub from 'pubsub-js';
import {
	CALENDAR_NORMAL,
	CHAT_KEY_PREFIX,
	EVENT_TOPIC_CONTACT_DETAILS_VISIBILITY,
} from '@src/Constants';
import '../../styles/ContactDetails.css';
import Moment from 'react-moment';
import googleLogo from '../../assets/images/ic-google.png';
import hubspotLogo from '../../assets/images/ic-hubspot.png';
import {
	debounce,
	extractAvatarFromContactProviderData,
	generateErrorMessage,
	replaceIfOnlyNewlines,
} from '@src/helpers/Helpers';
import { addPlus } from '@src/helpers/PhoneNumberHelper';
import { Trans, useTranslation } from 'react-i18next';
import PrintMessage from '../PrintMessage';
import { setFilterTag } from '@src/store/reducers/filterTagReducer';
import CustomAvatar from '@src/components/CustomAvatar';
import { useAppDispatch, useAppSelector } from '@src/store/hooks';
import SellIcon from '@mui/icons-material/Sell';
import { Check } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import {
	createCustomField,
	deleteCustomField,
	deleteCustomFieldOrganizationGetChat,
	getContactDetailsGetChat,
	updateContactDetailsGetChat,
	updateCustomField,
} from '@src/api/SudoApiService';
import CustomDialog from '../CustomDialog/CustomDialog';

interface CustomFields {
	key: string;
	value: string;
	error?: boolean;
	errorMessage?: string;
	updateIcon?: boolean;
	autoFocus?: boolean;
	setDrawerOpen?: (data: boolean) => void;
}
interface ContactDetails {
	phone: string;
	name: string;
	customFields: CustomFields[];
}

type Operation = 'create' | 'update';

interface BackUpLabel {
	index: number;
	value: string;
}

const ContactDetails: React.FC = ({
	contactData,
	setContactData,
	contactProvidersData,
	retrieveContactData,
	contactDetails,
	setContactDetails,
	organizationData,
	setOrganizationData,
	setDrawerOpen,
}) => {
	const currentUser: any = useAppSelector((state) => state?.currentUser?.value);
	const [keyField, setKeyField] = useState<boolean>(false);
	const [keyFieldInput, setKeyFieldInput] = useState<string>('');
	const [error, setError] = useState<boolean>(false);
	const [errorMessage, setErrorMessage] = useState<string>('');
	const [backUpLabel, setBackUpLabel] = useState();
	const [confirmDialog, setConfirmDialog] = useState(false);
	const [disableInput, setDisableInput] = useState(false);
	const { t } = useTranslation();
	const url = useLocation();
	const timeoutHandler = useRef(null);

	const chats = useAppSelector((state) => state.chats.value);

	const [chat, setChat] = useState({});

	const dispatch = useAppDispatch();

	const hideContactDetails = () => {
		PubSub.publish(EVENT_TOPIC_CONTACT_DETAILS_VISIBILITY, false);
	};

	const handleKeyChange = (e) => {
		setKeyFieldInput(e?.target?.value);
	};

	const handleValueChange = (e, index) => {
		let data: CustomFields[];
		data = contactDetails?.map((field, fieldIndex) => {
			if (index === fieldIndex) {
				field.value = e.target.value;
			}
			return field;
		});
		setContactDetails(data);

		//debounce
		if (timeoutHandler.current) {
			clearTimeout(timeoutHandler.current);
		}
		timeoutHandler.current = setTimeout(() => {
			try {
				updateField(index);
			} catch (err) {}
		}, 500);
	};

	const handleSelectLabel = (key, index, id) => {
		setBackUpLabel({ index: index, value: key, _id: id });
	};

	const addField = async () => {
		setDisableInput(true);
		let finalData: ContactDetails;
		if (contactDetails?.length) {
			const hasKey: Boolean = contactDetails?.some(
				(obj) => obj.key.toLowerCase()?.trim() === keyFieldInput?.toLowerCase()?.trim()
			);
			if (!hasKey) {
				if (keyFieldInput?.length > 0) {
					const filteredData: CustomFields[] = contactDetails?.map((field) => {
						return { key: field?.key?.trim(), value: field?.value?.trim() };
					});
					finalData = {
						phone: contactData?.phoneNumbers?.[0]?.phoneNumber,
						name: contactData?.name,
						customFields: [...filteredData, { key: keyFieldInput?.trim(), value: '' }],
					};
					const res = await createCustomField({ key: keyFieldInput?.trim() });
					setContactDetails([
						...contactDetails,
						{ key: keyFieldInput, value: '', autoFocus: true, _id: res?._id },
					]);
					setOrganizationData([
						...organizationData,
						{ key: keyFieldInput, value: '', _id: res?._id },
					]);
					setKeyField(false);
					setKeyFieldInput('');
					setDisableInput(false);
				} else {
					setError(true);
					setErrorMessage(`Label can't be empty`);
					setDisableInput(false);
				}
			} else {
				setError(true);
				setErrorMessage('Label Already Exist');
				setDisableInput(false);
			}
		} else {
			finalData = {
				phone: contactData?.phoneNumbers?.[0]?.phoneNumber,
				name: contactData?.name,
				customFields: [{ key: keyFieldInput?.trim(), value: '' }],
			};
			//updateContactFields(finalData, 'create');
			const res = await createCustomField({ key: keyFieldInput?.trim() });
			setContactDetails([
				{ key: keyFieldInput?.trim(), value: '', autoFocus: true, _id: res?._id },
			]);
			setOrganizationData([
				...organizationData,
				{ key: keyFieldInput?.trim(), value: '', _id: res?._id },
			]);
			setKeyField(false);
			setKeyFieldInput('');
			setDisableInput(false);
		}
	};

	const handleDiscard = async () => {
		try {
			let data = contactDetails?.map((field, index) => {
				if (index === backUpLabel?.index) {
					field.key = backUpLabel?.value;
				}
				return field;
			});

			await updateCustomField({ key: backUpLabel?.value }, backUpLabel?._id);
			data = contactDetails?.map((field, fieldIndex) => {
				if (fieldIndex === backUpLabel?.index) {
					field.key = backUpLabel?.value;
					field.updateIcon = false;
				}
				return field;
			});
			const orgData = organizationData?.map((fields) => {
				if (fields?._id === backUpLabel?._id) {
					fields.key = backUpLabel?.value;
				}
				return fields;
			});
			setContactDetails(data);
			setOrganizationData(orgData);
			setConfirmDialog(false);
		} catch (err) {
			console.log(err);
		}
	};

	const handleYes = async () => {
		try {
			const filteredFields = contactDetails?.filter((field, index) => index !== backUpLabel?.index);
			const orgData = organizationData?.filter((fields) => fields?._id !== backUpLabel?._id);
			await deleteCustomField(backUpLabel?._id);
			setContactDetails(filteredFields);
			setOrganizationData(orgData);
			setConfirmDialog(false);
		} catch (err) {}
	};

	// TODO: Load chat via API instead as it might not be loaded yet in chat list
	const findChatByWaId = () => {
		const waId = contactData?.waId;

		return chats[CHAT_KEY_PREFIX + waId];
	};

	const moveCursorToEnd = (element) => {
		const range = document.createRange();
		range.selectNodeContents(element);
		range.collapse(false);
		const selection = window.getSelection();
		selection.removeAllRanges();
		selection.addRange(range);
	};

	const updateKey = async (e, editableIndex) => {
		try {
			if (e?.target?.textContent?.length === 0) {
				setConfirmDialog(true);
			}

			const inputValue: HTMLElement = e.target.textContent;
			/* Allow only alphabetic characters, digits, and underscores or (#, -, _) */
			const sanitizedValue: string = inputValue.replace(/[^\w\s#\-_]/g, '');

			let data: CustomFields[] = contactDetails?.map((field, fieldIndex) => {
				if (fieldIndex === editableIndex) {
					field.key = sanitizedValue;
					field.updateIcon = true;
					field.error = false;
					field.errorMessage = '';
				}
				return field;
			});
			setContactDetails(data);

			const orgData = organizationData?.map((fields) => {
				if (fields?._id === backUpLabel?._id) {
					fields.key = sanitizedValue;
				}
				return fields;
			});

			//debounce
			if (timeoutHandler.current) {
				clearTimeout(timeoutHandler.current);
			}
			timeoutHandler.current = setTimeout(async () => {
				try {
					await updateCustomField({ key: sanitizedValue }, backUpLabel?._id);
					data = contactDetails?.map((field, fieldIndex) => {
						if (fieldIndex === editableIndex) {
							field.updateIcon = false;
						}
						return field;
					});
					setOrganizationData(orgData);
					setContactDetails(data);
				} catch (err) {}
			}, 500);

			e.target.textContent = sanitizedValue;
			moveCursorToEnd(e.target);
		} catch (err) {
		} finally {
		}
	};

	const updateField = async (editableIndex) => {
		let data: CustomFields[] = contactDetails?.map((field, fieldIndex) => {
			if (fieldIndex === editableIndex) {
				field.updateIcon = true;
				field.error = false;
				field.errorMessage = '';
			}
			return field;
		});
		const filteredData: CustomFields[] = data.map((field) => {
			return { key: field?.key?.trim(), value: field?.value?.trim() };
		});
		const finalData: ContactDetails = {
			phone: contactData?.phoneNumbers?.[0]?.phoneNumber,
			name: contactData?.name,
			customFields: filteredData,
		};
		updateContactFields(finalData, 'update', editableIndex);
		setContactDetails(data);
		//setUpdateFieldIcon(true);
	};

	const searchUserSpecificValue = (customFields) => {
		let data = [];
		let flag;
		if (customFields) {
			for (let i = 0; i < contactDetails?.length; i++) {
				flag = 0;
				for (let j = 0; j < customFields?.length; j++) {
					if (contactDetails?.[i]?.key === customFields?.[j]?.key) {
						flag = 1;
						data.push({
							key: contactDetails[i]?.key,
							value: customFields[j]?.value,
							_id: contactDetails[j]?._id,
						});
						break;
					}
				}
				if (flag !== 1) {
					data.push({ key: contactDetails[i]?.key, value: '', _id: contactDetails[i]?._id });
				}
			}
		} else {
			data = organizationData?.map((field) => {
				return { ...field, value: '' };
			});
		}
		return data;
	};

	const getContactFields = async () => {
		try {
			const res = await getContactDetailsGetChat(url?.pathname?.split('/')?.at(-1));
			const data = searchUserSpecificValue(res?.customFields);
			setContactDetails(data);
		} catch (err) {
			console.log(err);
		}
	};

	const updateContactFields = async (
		data: ContactDetails,
		operation: Operation,
		editableIndex: Number
	) => {
		try {
			if (operation === 'update') {
				await updateContactDetailsGetChat(data);
			}
		} catch (err) {
			if (operation === 'update') {
				let stateData: CustomFields[] = contactDetails?.map((field, fieldIndex) => {
					if (!field?.key?.length) {
						field.updateIcon = false;
						// field.error = true;
						// field.errorMessage = generateErrorMessage(err?.message);
					}
					return field;
				});
				setContactDetails(stateData);
			}
		} finally {
			if (operation === 'update') {
				let stateData: CustomFields[] = contactDetails?.map((field, fieldIndex) => {
					if (fieldIndex === editableIndex) {
						field.updateIcon = false;
					}
					return field;
				});
				setContactDetails(stateData);
			}
		}
	};

	useEffect(() => {
		retrieveContactData(contactData?.waId);
		setChat(findChatByWaId());
	}, []);

	// useEffect(() => {
	// 	getContactFields();
	// }, []);

	useEffect(() => {
		return () => {
			setContactDetails(organizationData);
		};
	}, []);

	return (
		<>
			{confirmDialog ? (
				<CustomDialog
					open={confirmDialog}
					setOpen={setConfirmDialog}
					handleClose={handleDiscard}
					handleYes={handleYes}
				/>
			) : null}
			<div className="contactDetails">
				<div className="contactDetails__header">
					<IconButton onClick={hideContactDetails} size="large">
						<CloseIcon />
					</IconButton>

					<h3>{t('Contact Details')}</h3>
				</div>

				{contactData && (
					<div className="contactDetails__body">
						<div className="contactDetails__body__section">
							<div className="contactDetails__body__avatarContainer">
								<CustomAvatar
									src={contactData?.contact?.waba_payload?.profile?.photo}
									className="contactDetails__body__avatar"
									generateBgColorBy={contactData?.name}
								>
									{contactData?.initials}
								</CustomAvatar>
							</div>
							<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
								<Typography
									variant="chatFont"
									style={{
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										width: '300px',
										whiteSpace: 'nowrap',
										display: 'block',
										textAlign: 'center',
										fontSize: '20px',
										fontWeight: '600',
										color: '#000',
									}}
								>
									{contactData?.companyName}
								</Typography>
							</div>

							{contactProvidersData[contactData.waId]?.[0]?.companies?.[0] !== undefined && (
								<div className="contactDetails__body__job">
									<span>
										{contactProvidersData[contactData.waId]?.[0]?.companies?.[0]?.job_title}
									</span>{' '}
									at{' '}
									<span>
										{contactProvidersData[contactData.waId]?.[0]?.companies?.[0]?.company_name}
									</span>
								</div>
							)}

							<div className="contactDetails__body__lastMessageAt">
								Last message:{' '}
								{contactData.lastMessageTimestamp && contactData.lastMessageTimestamp > 0 ? (
									<Moment unix calendar={CALENDAR_NORMAL}>
										{contactData.lastMessageTimestamp}
									</Moment>
								) : (
									t('Never')
								)}
							</div>

							{chat?.tags?.length > 0 && (
								<div className="contactDetails__body__tags mt-3">
									{chat?.tags.map((tag, index) => (
										<div
											className="contactDetails__body__tags__tag"
											key={index}
											onClick={() => dispatch(setFilterTag(tag))}
										>
											<SellIcon
												style={{
													fill: tag.web_inbox_color,
												}}
											/>
											<span className="bold">{tag.name}</span>
										</div>
									))}
								</div>
							)}

							{(chat?.assignedToUser || chat?.assignedGroup) && (
								<div className="contactDetails__body__assignees mt-3">
									{chat?.assignedToUser && (
										<div>
											<PersonIcon />
											<Trans
												values={{
													postProcess: 'sprintf',
													sprintf: [chat?.assignedToUser.username],
												}}
											>
												Assigned to: <span className="bold">%s</span>
											</Trans>
										</div>
									)}

									{chat?.assignedGroup && (
										<div>
											<GroupIcon />
											<Trans
												values={{
													postProcess: 'sprintf',
													sprintf: [chat?.assignedGroup.name],
												}}
											>
												Assigned group: <span className="bold">%s</span>
											</Trans>
										</div>
									)}
								</div>
							)}
						</div>

						<div className="contactDetails__body__section">
							<div className="contactDetails__body__section__title">{t('Virtual ID')}</div>
							<a>{chat?.waId}</a>
						</div>

						{/* <div className="contactDetails__body__section">
							<div className="contacts_keyField">
								{contactDetails?.map((field, index) => {
									return (
										<div style={{ width: '100%' }}>
											<div
												className="bold contact_label"
												contentEditable
												onSelect={() => handleSelectLabel(field?.key, index, field?._id)}
												onInput={(e) => updateKey(e, index)}
											>
												{field?.key}
											</div>
											<TextField
												variant="standard"
												sx={{ transition: '0.3s ease-in-out' }}
												value={replaceIfOnlyNewlines(field?.value)}
												//placeholder="Enter Value"
												error={field?.error}
												helperText={field?.errorMessage}
												onChange={(e) => handleValueChange(e, index)}
												//label={field?.key}
												size="medium"
												multiline={true}
												fullWidth={true}
												autoFocus={field?.autoFocus}
												InputProps={{
													endAdornment: (
														<InputAdornment position="end">
															{
																<Check
																	className={field?.updateIcon ? 'fade_in_out_show' : 'fade_in_out'}
																/>
															}
														</InputAdornment>
													),
												}}
												//onKeyUp={debounce((e) => handleValueChange(e, index), 100)}
											/>
										</div>
									);
								})}
								{keyField ? (
									<>
										<TextField
											variant="standard"
											sx={{ transition: '0.3s ease-in-out' }}
											value={keyFieldInput}
											//placeholder="Enter Label"
											onChange={(e) => handleKeyChange(e)}
											disabled={disableInput}
											error={error}
											helperText={errorMessage}
											label="Label"
											size="medium"
											multiline={true}
											fullWidth={true}
											autoFocus={true}
											onKeyDown={(e) => {
												if (e.key === 'Enter' && keyFieldInput?.trim()?.length > 0) {
													addField();
												}
											}}
										/>{' '}
									</>
								) : null}
								{!keyField ? (
									<Button onClick={() => setKeyField(true)} color="primary" variant="contained">
										Add Label
									</Button>
								) : (
									<div className="contacts_keyField_Btn_Wrapper">
										<Button
											onClick={() => {
												setKeyField(false);
												setError(false);
												setErrorMessage('');
											}}
											color="primary"
											variant="contained"
										>
											Cancel
										</Button>
										<Button
											onClick={addField}
											color="primary"
											variant="contained"
											disabled={!keyFieldInput?.trim()?.length}
										>
											Save
										</Button>
									</div>
								)}
							</div>
						</div> */}

						{contactProvidersData[contactData.waId]?.map((providerData, index) => (
							<div className="contactDetails__body__section" key={providerData.contact_provider.id}>
								<div className="contactDetails__body__section__title mb-3">
									<div className="contactDetails__body__section__providerTitle">
										{providerData.contact_provider.type === 'google' && (
											<img
												className="mr-1"
												src={googleLogo}
												alt={providerData.contact_provider.name}
											/>
										)}
										{providerData.contact_provider.type === 'hubspot' && (
											<img
												className="mr-1"
												src={hubspotLogo}
												alt={providerData.contact_provider.name}
											/>
										)}
										{providerData.contact_provider.name}
									</div>
								</div>

								<div className="contactDetails__body__section__content mb-2">
									<div className="contactDetails__body__section__subtitle">{t('Phone number')}</div>
									<div className="contactDetails__body__section__content__sub">
										{providerData.phone_numbers?.map((phoneNumber, phoneNumberIndex) => (
											<div key={phoneNumberIndex}>
												<a href={'tel:' + addPlus(phoneNumber.phone_number)}>
													<span>{addPlus(phoneNumber.phone_number)}</span>
												</a>
												{phoneNumber.description && (
													<span className="ml-1">({phoneNumber.description})</span>
												)}
											</div>
										))}
									</div>
								</div>

								<div className="contactDetails__body__section__content">
									<div className="contactDetails__body__section__subtitle">{t('E-mail')}</div>
									<div className="contactDetails__body__section__content__sub">
										{providerData.email_addresses?.map((emailAddress, emailAddressIndex) => (
											<div key={emailAddressIndex}>
												<a href={'mailto:' + emailAddress.email_address}>
													{emailAddress.email_address}
												</a>
												{emailAddress.description && (
													<span className="ml-1">({emailAddress.description})</span>
												)}
											</div>
										))}
									</div>
								</div>
							</div>
						))}
					</div>
				)}
			</div>
		</>
	);
};

export default ContactDetails;
